import { useCallback, useState, useEffect } from "react";
import useLocalStorage from "./LocalStorage";

export default function useAddToHomeScreen() {
    const [homeScreenData, setHomeScreenData] = useLocalStorage('homeScreenData', {
        dontShowBefore: (new Date('2000-01-01')).getTime()
    });
    const [itIsTimeToShowTheMessage, setIsTimeToShowTheMessage] =
        useState(Date.now() > homeScreenData.dontShowBefore);

    const snooze = useCallback(() => {
        let today = new Date();
        let tomorrow = new Date();
        tomorrow.setDate(today.getDate() + 1); // 1d
        tomorrow.setHours(3); // at 3am
        setHomeScreenData({ dontShowBefore: tomorrow.getTime() });
        // setHomeScreenData({ dontShowBefore: today.getTime() + 1000 * 15 }); // 15s
    }, [setHomeScreenData]);

    useEffect(() => {
        let newValue = Date.now() > homeScreenData.dontShowBefore;
        setIsTimeToShowTheMessage(newValue);

        if (!newValue) {
            let i = setInterval(() => {
                setIsTimeToShowTheMessage(Date.now() > homeScreenData.dontShowBefore);
            }, 1000 * 60 * 60) // 1h
            // }, 1000 * 10) // 10s
    
            return () => {clearInterval(i)};
        }
    }, [homeScreenData.dontShowBefore, itIsTimeToShowTheMessage]);

    return [
        snooze,
        itIsTimeToShowTheMessage
    ]
}
